import { render, staticRenderFns } from "./warningTop.vue?vue&type=template&id=067dda94&scoped=true&"
import script from "./warningTop.vue?vue&type=script&lang=js&"
export * from "./warningTop.vue?vue&type=script&lang=js&"
import style0 from "./warningTop.vue?vue&type=style&index=0&id=067dda94&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067dda94",
  null
  
)

export default component.exports